import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
}
const qsAll = {
  sections: 'data-section-type="related-products"',
}

const initSlider = (section) => {
  const sectionSwiper = new Swiper(section.querySelector(`[${qs.swiper}]`), {
    slidesPerView: 2,
    spaceBetween: 16,
    speed: 300,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  })
}

export const setupRelatedProducts = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => initSlider(section))
}